import img1 from "../assets/projects/project1.jpg";
import img2 from "../assets/projects/project2.webp";
import img3 from "../assets/projects/project3.webp";
import img4 from "../assets/projects/project4.webp";
import img5 from "../assets/projects/project5.webp";

const whyChooseCarouselData = [
  {
    id: 1,
    title: "Basketball Court",
    location: "Delhi",
    surface: "Acrylic Surface",
    image: img1,
  },

  {
    id: 2,
    title: "Running Track",
    location: "Noida",
    surface: "Synthetic Track",
    image: img2,
  },

  {
    id: 3,
    title: "Football Turf",
    location: "Lucknow",
    surface: "Artificial Grass",
    image: img3,
  },

  {
    id: 4,
    title: "Badminton Court",
    location: "Gurugram",
    surface: "PVC Flooring",
    image: img4,
  },

  {
    id: 5,
    title: "Tennis Court",
    location: "Jaipur",
    surface: "Synthetic Acrylic",
    image: img5,
  },
];

export default whyChooseCarouselData;
